import React, { useMemo } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';

import { useNewRefuel } from '../../../../../hooks/useNewRefuel';

import { TooltipContent, Title, Text, TextWrapper } from './styles';

const CardHeader: React.FC = () => {
  const { enabledStep } = useNewRefuel();

  const contentTooltip = useMemo(() => {
    if (enabledStep === 2) {
      return {
        title: 'Nível do gás',
        text: 'Mantenha seu estoque de gás em 80% para evitar imprevistos e garantir a continuidade das operações do seu negócio.',
      };
    }
    if (enabledStep === 3) {
      return {
        title: 'Horário de entrega',
        text: 'O abastecimento do seu estabelecimento ocorrerá o mais próximo possível do horário cadastrado em Melhores horários. No entanto, podem ocorrer imprevistos.',
      };
    }
    if (enabledStep === 4) {
      return {
        title: 'Quem poderá receber?',
        text: 'Visando a segurança a central de GLP deve ser operada e supervisionada por uma pessoa com idade mínima de 18 anos.',
      };
    }
    if (enabledStep === 5) {
      return {
        title: 'Ajude-nos a prevenir acidentes!',
        text: 'Mantenha a área da central de gás livre de materiais inflamáveis (madeira, papel, tintas, etc.).',
      };
    }
    return null;
  }, [enabledStep]);

  return (
    <TooltipContent>
      <AiOutlineWarning size={18} color="#F5A623" />
      <TextWrapper>
        <Title>{contentTooltip?.title}</Title>
        <Text>{contentTooltip?.text}</Text>
      </TextWrapper>
    </TooltipContent>
  );
};

export default CardHeader;
